if (typeof CustomerAPIUtils === "undefined") {
  class CustomerAPIUtils {
    constructor() {
      this.currentCustomerData = null;
      this.username = "shopifyCustomerService";
      this.password = "lhViZUUsiLJjzn6lSTrF";
      this.credentials = btoa(this.username + ":" + this.password);
      this.shopDomain =
        window.shopDomain || window.shopify?.shop || window.location.hostname;
    }

    async fetchCustomerData(nileCard) {
      if (!nileCard) {
        console.warn("fetchCustomerData: No Nile card provided");
        return null;
      }

      const payload = {
        nilecard: nileCard,
      };

      try {
        const response = await fetch(
          window.endpointRouteToUseLobster[this.shopDomain] +
            "/dw/Request/dxjsmtq4mjkzotcxmb/v1",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic " + this.credentials,
              "X-SHOPIFY-SHOP-DOMAIN": this.shopDomain,
            },
            body: JSON.stringify(payload),
          }
        );

        if (response.ok) {
          const customerData = await response.json();
          this.currentCustomerData = customerData;
          return customerData;
        }
      } catch (error) {}
      return null;
    }

    async fetchShopifyCustomer(email = null) {
      if (!this.shopDomain) {
        console.error("fetchShopifyCustomer: No shop domain found");
        return null;
      }

      try {
        //console.log(window.shopifyActionsApiKey , 'window.shopifyActionsApiKey');
        const response = await fetch(
          "https://discount-extension-nile.shopify-apps.aico.swiss/app/customer",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key":  window.shopifyActionsApiKey || "bjbT&@nAm@7CRSZh2dut0-gVDnksr" ,
            },
            body: JSON.stringify({ 
              shop: this.shopDomain,
              email: email || window.customerEmail || "",
            }),
          }
        );

        if (response.ok) {
          const customerData = await response.json();
          return customerData;
        } else {
          console.warn("Failed to fetch Shopify customer:", response.status);
          return null;
        }
      } catch (error) {
        console.error("Error fetching Shopify customer:", error);
        return null;
      }
    }

    async updateMainAddressInLobster(addressData) {
      if (!this.currentCustomerData) {
        console.warn("updateMainAddressInLobster: No customer data available");
        return false;
      }

      const payload = {
        address: {
          LoyaltyCard: this.currentCustomerData.LoyaltyCard,
          Country: addressData.country,
          ZipCode: addressData.zip,
          City: addressData.city,
          Street: addressData.address1,
          Name: `${addressData.firstName} ${addressData.lastName}`,
        },
      };

      try {
        const response = await fetch(
          window.endpointRouteToUseLobster[this.shopDomain] +
            "/dw/Request/dxjsmtq4mjkzotcxmd/v1",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic " + this.credentials,
              "X-SHOPIFY-SHOP-DOMAIN": this.shopDomain,
            },
            body: JSON.stringify(payload),
          }
        );
        if (response.ok) {
          const updatedData = await response.json();
          return true;
        }
      } catch (error) {
        console.error("Error updating main address in Lobster:", error);
      }
      return false;
    }

    async setShopifyAddress(payload) {
      if (!payload.actionType) {
        console.error("setShopifyAddresses: actionType is required");
        return false;
      }

      const shopDomain = this.shopDomain;

      try {
        const response = await fetch(
          "https://discount-extension-nile.shopify-apps.aico.swiss/app/customer/address",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": window.shopifyActionsApiKey || "",
            },
            body: JSON.stringify({ ...payload, shop: shopDomain }),
          }
        );

        if (response.ok) {
          return true;
        } else {
          console.warn("Failed to set Shopify addresses:", response.status);
          return false;
        }
      } catch (error) {
        console.error("Error setting Shopify addresses:", error);
        return false;
      }
    }

    async fetchKlaviyoProfile(customerEmail) {
      if (!customerEmail) {
        console.error("fetchKlaviyoProfile: No customer email provided");
        return null;
      }

      const klaviyoEndpoint =
        window.endpointRouteToUseKlaviyoProfile[this.shopDomain];

      try {
        const response = await fetch(
          `${klaviyoEndpoint}?email=${encodeURIComponent(customerEmail)}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": window.klaviyoApiKey || "",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error fetching Klaviyo profile:", error);
        return null;
      }
    }

    async updateKlaviyoMarketingConsent(customerEmail, subscribe) {
      if (!customerEmail) {
        console.error(
          "updateKlaviyoMarketingConsent: No customer email provided"
        );
        return false;
      }

      const klaviyoEndpoint =
        window.endpointRouteToUseKlaviyoConsent[this.shopDomain];

      const payload = {
        email: customerEmail,
        marketing_consent: subscribe,
      };

      try {
        const response = await fetch(klaviyoEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": window.klaviyoApiKey || "",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (data.success === true) {
          console.log("Klaviyo subscription updated successfully");
          return true;
        } else {
          console.error(
            "Klaviyo API returned error:",
            data.error || "Unknown error"
          );
          return false;
        }
      } catch (error) {
        console.error("Error updating Klaviyo subscription:", error);
        return false;
      }
    }

    async updateCustomerData(updatePayload) {
      if (!this.currentCustomerData) {
        return false;
      }

      if (
        updatePayload?.customerData?.Language &&
        !["de", "it", "fr", "en"].includes(updatePayload.customerData.Language)
      ) {
        return false;
      }

      try {
        const response = await fetch(
          window.endpointRouteToUseLobster[this.shopDomain] +
            "/dw/Request/dxjsmtq4mjkzotcxma/v1",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic " + this.credentials,
              "X-SHOPIFY-SHOP-DOMAIN": this.shopDomain,
            },
            body: JSON.stringify(updatePayload),
          }
        );

        if (response.ok) {
          try {
            const responseText = await response.text();
            const updatedData = JSON.parse(responseText);
            this.currentCustomerData = updatedData;
            return updatedData;
          } catch (parseError) {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    }

    async updateKlaviyoProfile(
      firstName,
      lastName,
      birthday,
      originalCustomerData = null,
      language = null,
      regularPoint = null,
      country = null,
      shopDomain = null
    ) {
      if (language && !["de", "it", "fr", "en"].includes(language)) {
        return false;
      }

      const customerData = originalCustomerData || this.currentCustomerData;

      const email =
        window.customerEmail ||
        (customerData ? customerData.Email || customerData.Mail : null);

      if (!email) {
        console.warn("Klaviyo update: No email available");
        return false;
      }

      const klaviyoPayload = {
        email: email,
      };
      if (regularPoint !== undefined && regularPoint !== null) {
        klaviyoPayload.regular_pos = regularPoint;
      }

      if (firstName) {
        klaviyoPayload.first_name = firstName;
      }
      if (lastName) {
        klaviyoPayload.last_name = lastName;
      }
      if (birthday) {
        const birthdayDate = new Date(birthday);
        if (!isNaN(birthdayDate.getTime())) {
          const year = birthdayDate.getFullYear();
          const month = (birthdayDate.getMonth() + 1)
            .toString()
            .padStart(2, "0");
          const day = birthdayDate.getDate().toString().padStart(2, "0");
          klaviyoPayload.birth_date = `${year}/${month}/${day}`;
        }
      }

      if (language) {
        klaviyoPayload.language = language;
      }

      if (country) {
        klaviyoPayload.country = country;
      }

      if(shopDomain) {
        klaviyoPayload.shop = shopDomain;
      }

      if (!window.endpointRouteToUseKlaviyoProfile[this.shopDomain]) {
        console.error(
          "Klaviyo update: No endpoint found for shop domain:",
          this.shopDomain
        );
        return false;
      }

      if (!window.klaviyoApiKey) {
        console.error("Klaviyo update: No API key found");
        return false;
      }

      try {
        const response = await fetch(
          window.endpointRouteToUseKlaviyoProfile[this.shopDomain],
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": window.klaviyoApiKey || "",
            },
            body: JSON.stringify(klaviyoPayload),
          }
        );

        if (!response.ok) {
          const responseText = await response.text();
          console.error("Klaviyo response error:", responseText);
        }

        return response.ok;
      } catch (error) {
        console.error("Klaviyo profile update error:", error);
        return false;
      }
    }

    async sendLobsterProfileToShopify() {
      const regularPoint = this.currentCustomerData.RegularPoint;
      await this.updateKlaviyoProfile(
        null,
        null,
        null,
        null,
        null,
        regularPoint,
        null,
        this.shopDomain
      );

      if (!this.currentCustomerData) {
        console.error(
          "sendLobsterProfileToShopify: No customer data available"
        );
        return false;
      }

      const shopDomain = this.shopDomain;

      if (!shopDomain) {
        console.error("sendLobsterProfileToShopify: No shop domain found");
        return false;
      }

      const customerSyncPayload = {
        shop: shopDomain,
        lobsterProfile: this.currentCustomerData,
        email: window.customerEmail,
      };

      try {
        const response = await fetch(
          "https://discount-extension-nile.shopify-apps.aico.swiss/app/customer/sync-lobster",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(customerSyncPayload),
          }
        );

        if (response.ok) {
          console.log("Update Lobster Profile in Shopify successful");
          return true;
        } else {
          const errorText = await response.text().catch(() => "Unknown error");
          console.warn(
            "Update Lobster Profile in Shopify failed:",
            response.status,
            errorText
          );

          if (response.status === 0 || response.status === 403) {
            console.error(
              "CORS error detected. This might be a cross-origin issue."
            );
          }

          return false;
        }
      } catch (error) {
        console.error("Error updating Lobster Profile in Shopify:", error);

        if (
          error.name === "TypeError" &&
          error.message.includes("Failed to fetch")
        ) {
          console.error(
            "Network/CORS error detected. Check if the endpoint allows cross-origin requests."
          );
        }

        return false;
      }
    }

    getCurrentCustomerData() {
      return this.currentCustomerData;
    }

    setCurrentCustomerData(data) {
      this.currentCustomerData = data;
    }

    createPersonalInfoPayload(firstName, lastName, birthday) {
      if (!this.currentCustomerData) {
        return null;
      }

      const cleanedAddresses = (this.currentCustomerData.addresses || [])
        .map((addr) => ({
          ...addr,
          ZipCode: addr.ZipCode || "",
          City: addr.City || "",
          Street: addr.Street || "",
        }))
        .filter(
          (addr) => addr.AddressId && (addr.ZipCode || addr.City || addr.Street)
        );

      const payload = {
        customerData: {
          Birthday: birthday || this.currentCustomerData.Birthday,
          Mail: this.currentCustomerData.Mail || false,
          Newsletter: this.currentCustomerData.NewsLetter || false,
          FirstName: firstName || this.currentCustomerData.FirstName,
          LastName: lastName || this.currentCustomerData.LastName,
          LoyaltyCard: this.currentCustomerData.LoyaltyCard,
        },
      };

      if (cleanedAddresses.length > 0) {
        payload.customerData.Addresses = cleanedAddresses;
      }

      return payload;
    }

    createMarketingPayload(mail, newsletter) {
      if (!this.currentCustomerData) {
        return null;
      }

      const cleanedAddresses = (this.currentCustomerData.addresses || [])
        .map((addr) => ({
          ...addr,
          ZipCode: addr.ZipCode || "",
          City: addr.City || "",
          Street: addr.Street || "",
        }))
        .filter(
          (addr) => addr.AddressId && (addr.ZipCode || addr.City || addr.Street)
        );

      const payload = {
        customerData: {
          Birthday: this.currentCustomerData.Birthday,
          Mail: mail,
          Newsletter: newsletter,
          FirstName: this.currentCustomerData.FirstName,
          LastName: this.currentCustomerData.LastName,
          LoyaltyCard: this.currentCustomerData.LoyaltyCard,
        },
      };

      if (cleanedAddresses.length > 0) {
        payload.customerData.Addresses = cleanedAddresses;
      }

      return payload;
    }
  }

  if (typeof window.customerAPIUtils === "undefined") {
    window.customerAPIUtils = new CustomerAPIUtils();
  }
}
